$(document).ready(function(){
  	// Scroll to step1 on click of Join button   
  	$("#join_button").click(function() {
    	$('#subscription_step1').show();
      	scroll_to_div('#subscription_step1');
  	});
  
  	// Scroll to Step 2 on click of options from Step 1
	$("#subscription_step1 .pagels").click(function() {
      	var title = $(this).attr('data-title');
    	var classname = $(this).attr('data-class');
      
      	$('#total_recurring_amount').text( '' );
      	$('#pagel_order_total_pagels').text('');
    	$("#subscription_step1 .packagebox").removeClass('pro-selected');
    	$(this).addClass('pro-selected');
      	$('#subscription_step2').show();
    	$('.product-subscription').show();
      	$('#subscription_step2_bag').hide();
    	$('#subscription_bag_collection').hide();
      	scroll_to_div('#subscription_step2');
      	$(".pagel-order-section").show();
      	$('#pagel_order_selected_package').text(title);
      	$("#total_quantity").val(0);
      	$("input[name='quantity']").val(0);
      	$("input[name='quantity']").hide();
  });
  
  $("#subscription_step1 .bagels").click(function() {      
    	var title = $(this).attr('data-title');
    	$("#subscription_step1 .packagebox").removeClass('pro-selected');
    	$("#subscription_bag_collection .thumbnail ").removeClass('pro-selected');
    	$(this).addClass('pro-selected');
    
    	$('#total_recurring_amount').text( '' ); 
    	$('#pagel_order_total_pagels').text('');
    	$('#subscription_step2_bag').show();
    	$('#subscription_bag_collection').show();
   		$('.bag-subscription').show();
    	$('#subscription_step2').hide();
    	$('#your-pagel-section h2').hide();
    	$('.pagel-box-section').hide(); 
    	$(".pagel-box-section").html('');
    	$('.product-subscription').hide();
    	scroll_to_div('#subscription_step2_bag');
    	$(".pagel-order-section").show();
    	$('#pagel_order_selected_package').text(title);
  });  
  // Start code to add span to Your word in "Your pagel club order"
  
  /* Get the text of the element I'm after */
   var niceText = $('.pagel-order-section-title').text(),
      openSpan = '<span>', closeSpan = '</span>';

   /* Make the sentence into an array */
   niceText = niceText.split(' ');

   /* Add span to the beginning of the array */
   niceText.unshift( openSpan );

   /* Add  as the 3rd value in the array */
   niceText.splice( 2, 0, closeSpan );					

   /* Turn it back into a string */
   niceText = niceText.join(' ');					

   /* Append the new HTML to the header */
   $('.pagel-order-section-title').html( niceText );
  
   // End code to add span to Your word in "Your pagel club order"
  
  // Function to add multiple products to cart on click of "Complete My Membership" and "Continue" button
  $("#add_pagels_to_cart, #continue_to_cart").click(function(e){
    Shopify.queue = [];
                                 
	$('.pagel-subscription .thumbnail').each(function(){
      	var product_qty = $(this).find('.quantity').val();
      	if( product_qty > 0 )
        {
          Shopify.queue.push({
              variantId: $(this).find('.product-form input[name="id"]').val(),
              variantQuantity: product_qty*4
          });
        }
  	});
    
    $('.bag-subscription .thumbnail.pro-selected').each(function(){      	
          Shopify.queue.push({
              variantId: $(this).find('.product-form input[name="id"]').val(),
              variantQuantity: 1
          });
        
  	});
  	
  	Shopify.moveAlong = function() {
	  // If we still have requests in the queue, let's process the next one.
	  if (Shopify.queue.length) {
	    var request = Shopify.queue.shift();
	    var data = 'id='+ request.variantId + '&quantity='+request.variantQuantity;
        
	    $.ajax({
	      type: 'POST',
          url: '/cart/add.js',
	      dataType: 'json',
	      data: data,
	      success: function(res){
              Shopify.moveAlong();
          },
          error: function(){
	     	// if it's not last one Move Along else redirect to cart page
		  	if (Shopify.queue.length)
            {
		    	Shopify.moveAlong()
		  	} 
            else 
            {
              $(".cart-button").trigger('click');
		  	}
	      }
        });
      }
	  // If the queue is empty, we redirect to cart page
      else 
      {
	  	$(".cart-button").trigger('click');
	  }
    };
    Shopify.moveAlong();
  });
  
  // Product details popup and slider
  $(".product-fancybox").fancybox();
  
  // Plus minus click on fancybox
  $('body').on('click','.fancy-ctrl-btn',function(e){
    e.preventDefault();
    var el = $(this);
    var id = el.parents('.fancy-product').data('id');

    if(el.hasClass('cc-add')) {
      $('#'+id+' .qtyplus').trigger('click');
    } else {
      $('#'+id+' .qtyminus').trigger('click');
    }
  });
  
  // Highlight Pagels menu as per mockup on pagel-club page
  if(window.location.href.indexOf("pagel-club") > -1) {
    $(".menu a[href='/collections/our-products']").addClass('active');
  }
  
  // Fix for responsive issue on product detail page below slider
  $('ul.slides li').not('.flex-active-slide').hide();
});

$(window).load(function() {
  	// Subscription option should come first and one time should be after that
  	if( $(".bold-ro__recurring-div").length > 0 )
    {
      var rdiv = $(".bold-ro__recurring-div")[0].outerHTML;
      $(".bold-ro__recurring-div").remove();
      $(".bold-ro__recurring-title").after(rdiv);
      $(".bold-ro__recurring-div input").trigger('click');
      $(".bold-ro__product").show();
    }
});

// Scroll to specific div
function scroll_to_div( element )
{
  var p = ( $(window).width() < 768 ) ? ( element == '.pagel-order-section' ? $(element).offset().top+150+(420*3) : $(element).offset().top+70 ) : $(element).offset().top-40;  
  var h = $('.header').height();
  $("html, body").animate({ scrollTop: p-h }, "slow");
}
  